/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Column_TermInputs */



/**
* | output |
* | --- |
* | "Term" |
*
* @param {Knp_Terms_Column_TermInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_column_term = /** @type {((inputs?: Knp_Terms_Column_TermInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Column_TermInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Begriff")
	if (locale === "it") return /** @type {LocalizedString} */ ("Termine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Срок")
	if (locale === "es") return /** @type {LocalizedString} */ ("Término")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("学期")
	if (locale === "ja") return /** @type {LocalizedString} */ ("学期")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Prazo")
	return /** @type {LocalizedString} */ ("Term")
});